module.exports = __webpack_public_path__ + "img/bg_320.934c9345.png";